// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"68":"2f02a0","123":"e89e99","217":"0dc76e","358":"c34361","896":"7eee90"}[chunkId] + ".js";
};